import { cloneDeep } from 'lodash'
import baseConfig, { pageSearch as basePageSearch } from './salePlanCountList'

export const pageSearch = cloneDeep(basePageSearch)

const config = cloneDeep(baseConfig)
delete config.gjahr

export default config




// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanCountList02.js